import { Col, Row } from 'react-bootstrap';
import React, { useEffect, useState } from 'react';

import Img from 'gatsby-image';
import ReactMarkdown from 'react-markdown';
import SEO from '../../components/seo';
import SidePhoto from '../../components/SidePhoto';
import TrailTitle from '../../components/TrailTitle';
import { graphql } from 'gatsby';

const EmergencyPage = ({ data, location }) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen((o) => !o);

    return () => {
      setOpen((o) => !o);
    };
  }, []);

  return (
    <>
      <SEO title='Layanan Gawat Darurat' pathname='/services/emergency' />
      <Img fluid={data.cover.childImageSharp.fluid} />
      <Row
        css={{
          minHeight: '75vh',
          backgroundImage: `url(${data.bg.childImageSharp.fixed.src})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'top right',
        }}
        className='pt-5'>
        <Col
          sm={'5'}
          className='d-flex flex-column align-items-center align-content-center'
          css={{ justifyContent: 'space-between' }}>
          <TrailTitle open={open} className='pb-2 mb-5'>
            <div>Layanan</div>
            <div>Gawat Darurat</div>
          </TrailTitle>
          <SidePhoto>
            {data.other_img.edges.map((img, idx) => (
              <Img key={idx} fluid={img.node.childImageSharp.fluid} />
            ))}
          </SidePhoto>
        </Col>
        <Col className='d-flex flex-column align-items-center align-content-center pl-3 pr-3 pt-1'>
          <ReactMarkdown
            source={data.emergency.description.value}
            escapeHtml={false}
          />
        </Col>
      </Row>
    </>
  );
};

export const query = graphql`
  {
    emergency: cockpitServices(cockpitId: { eq: "5fd9dbe231383320510000ee" }) {
      description {
        type
        value
      }
    }
    bg: file(name: { eq: "bg-ring" }) {
      childImageSharp {
        fixed(toFormat: WEBP) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }
    cover: file(name: { eq: "bg-igd" }) {
      childImageSharp {
        fluid(toFormat: WEBP) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    other_img: allFile(filter: { name: { in: ["LAYANAN IGD 1", "LAYANAN IGD 2"] } }) {
      edges {
        node {
          name
          childImageSharp {
            fluid(toFormat: WEBP) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    }
  }
`;

export default EmergencyPage;
